import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/modules/shared-area/root-state';

export const chemInfoState = (state: IAppState) => state;
export const userState = (state: IAppState) => state.shared.user;

export const getUser = createSelector(userState, state => state ? state.userData : null);
export const getUsername = createSelector(getUser, user => (user ? user.name : ''));
export const getUserUid = createSelector(getUser, user => (user ? user.sub : ''));
export const getUserCulture = createSelector(getUser, user => (user ? user.culture : undefined));
